import { Either, Left, Right } from "core/types/Either";
import { WalletRepository } from "domain/repository/WalletRepository";
import {
  AppleWalletPass,
  GoogleWalletPass,
  WalletPassParams,
} from "domain/entity/WalletPass";
import { WalletRemoteDataSource } from "data/dataSource/WalletRemoteDataSource";

export class WalletRepositoryImpl extends WalletRepository {
  private remoteDataSource: WalletRemoteDataSource;

  constructor(remoteDataSource: WalletRemoteDataSource) {
    super();
    this.remoteDataSource = remoteDataSource;
  }

  async getAppleWalletPass(
    params: WalletPassParams
  ): Promise<Either<Error, AppleWalletPass>> {
    try {
      const response = await this.remoteDataSource.getAppleWalletPass(params);
      return Right(new AppleWalletPass(response.blob, response.correlationId));
    } catch (e) {
      return Left(e instanceof Error ? e : new Error(String(e)));
    }
  }

  async getGoogleWalletPass(
    params: WalletPassParams
  ): Promise<Either<Error, GoogleWalletPass>> {
    try {
      const response = await this.remoteDataSource.getGoogleWalletPass(params);
      return Right(new GoogleWalletPass(response.url, response.correlationId));
    } catch (e) {
      return Left(e instanceof Error ? e : new Error(String(e)));
    }
  }
}
